/**
 * ローディング表示
 * @returns
 */
const Loading = () => {
  return (
    <div className="w-full h-full api-loading-screen-frame">
      <p>Now Loading...</p>
    </div>
  );
};
export default Loading;
